import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AbpHttpInterceptor } from "abp-ng2-module";

import * as ApiServiceProxies from "./service-proxies";

@NgModule({
  providers: [
    ApiServiceProxies.RoleServiceProxy,
    ApiServiceProxies.SessionServiceProxy,
    ApiServiceProxies.TenantServiceProxy,
    ApiServiceProxies.UserServiceProxy,
    ApiServiceProxies.TokenAuthServiceProxy,
    ApiServiceProxies.AccountServiceProxy,
    ApiServiceProxies.ConfigurationServiceProxy,
    ApiServiceProxies.ExternalTransferServiceProxy,
    ApiServiceProxies.CurrencyServiceProxy,
    ApiServiceProxies.CompanyServiceProxy,
    ApiServiceProxies.CountryServiceProxy,
    ApiServiceProxies.OutgoingTransferServiceProxy,
    ApiServiceProxies.IncomeTransferServiceProxy,
    ApiServiceProxies.CountryServiceProxy,
    ApiServiceProxies.CurrencyServiceProxy,
    ApiServiceProxies.ExpenseServiceProxy,
    ApiServiceProxies.IncomeServiceProxy,
    ApiServiceProxies.CompanyServiceProxy,
    ApiServiceProxies.ClientServiceProxy,
    ApiServiceProxies.ProvinceServiceProxy,
    ApiServiceProxies.CommisionServiceProxy,
    ApiServiceProxies.TreasuryBalanceServiceProxy,
    ApiServiceProxies.ExchangePriceServiceProxy,
    ApiServiceProxies.GeneralSettingServiceProxy,
    ApiServiceProxies.MigrationServiceProxy,
    ApiServiceProxies.ExchangeCurrencyServiceProxy,
    ApiServiceProxies.ClientCashFlowServiceProxy,
    ApiServiceProxies.CompanyCashFlowServiceProxy,
    ApiServiceProxies.TreasuryCashFlowServiceProxy,
    ApiServiceProxies.ManagementServiceProxy,
    ApiServiceProxies.PdfClientServiceProxy,
    ApiServiceProxies.PdfClientAndCompanyServiceProxy,
    ApiServiceProxies.PdfCompanyServiceProxy,
    ApiServiceProxies.PdfTreasuryBalanceServiceProxy,
    ApiServiceProxies.PdfTreasuryActionServiceProxy,
    ApiServiceProxies.TreasuryActionServiceProxy,
    ApiServiceProxies.CustomerServiceProxy,
    ApiServiceProxies.IncomeTransferDetailServiceProxy ,
    ApiServiceProxies.LinkTransferServiceProxy ,
    ApiServiceProxies.PdfOutgoingTransferServiceProxy,
    { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
  ],
})
export class ServiceProxyModule {}
